import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { formatEuro, formatEuroHighPrecision, formatQuantity, formatPercent } from '../../utils/currency';

interface ETFAnalyticsData {
  symbol: string;
  totalShares: number;
  averagePrice: number;
  totalInvested: number;
  currentValue: number;
  gainLoss: number;
  gainLossPercentage: number;
  dividends: number;
}

interface EtfAnalyticsDialogProps {
  open: boolean;
  onClose: () => void;
  data: ETFAnalyticsData | null;
}

const EtfAnalyticsDialog: React.FC<EtfAnalyticsDialogProps> = ({ open, onClose, data }) => {
  if (!data) return null;
  const rows: Array<[string, string]> = [
    ['Símbolo', data.symbol],
    ['Unidades', formatQuantity(data.totalShares)],
    ['Preço médio', formatEuroHighPrecision(data.averagePrice)],
    ['Total investido', formatEuro(data.totalInvested)],
    ['Valor atual', formatEuro(data.currentValue)],
    ['Lucro/Prejuízo', `${formatEuro(data.gainLoss)} (${formatPercent(data.gainLossPercentage)})`],
    ['Dividendos', formatEuro(data.dividends)]
  ];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Análise do ETF - {data.symbol}</DialogTitle>
      <DialogContent>
        {rows.map(([label, value]) => (
          <Box key={label} display="flex" justifyContent="space-between" py={0.5}>
            <Typography variant="body2" color="text.secondary">{label}</Typography>
            <Typography variant="body2" fontWeight="bold">{value}</Typography>
          </Box>
        ))}
        <Box mt={2}>
          <Typography variant="caption" color="text.secondary">
            Resumo básico; mais tarde será melhorado com gráficos e tendências históricas.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EtfAnalyticsDialog;